import React, { memo, useCallback, useRef } from 'react';
import { View } from 'react-native';

export const MeasurableView = memo(({ onMeasure, ...rest }) => {
  const elementRef = useRef(null);

  const onLayout = useCallback(() => {
    elementRef.current.measureInWindow((x, y, width, height) => {
      onMeasure && onMeasure({ x, y, width, height });
    });
  }, [onMeasure]);

  return <View ref={elementRef} {...rest} {...{ onLayout }} />;
});
